import axios from 'axios';
// config
import { HOST_API } from '../config';
import { refreshAccessToken } from './authRefresh';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
    baseURL: HOST_API,
});

axiosInstance.interceptors.response.use(
    (res) => res,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newAccess = await refreshAccessToken();
                if (!newAccess) return Promise.reject(error);
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = `Bearer ${newAccess}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                if (refreshError?.clearSession && !window.location.pathname.includes('/login')) {
                    window.location.href = '/';
                }
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject((error.response && error.response.data) || 'Something went wrong');
    }
);

export default axiosInstance;
